import apiClient from './apiClient';
import logger from './logger';

export const getConversations = async (userId, language) => {
  try {
    logger.debug('Fetching conversations for:', { userId, language });
    const response = await apiClient.get(`/api/conversations/${userId}/${language}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    logger.debug('Fetched conversations:', data);
    return data;
  } catch (error) {
    logger.error('Error fetching conversations:', error);
    throw error;
  }
};

export const saveConversation = async (userId, language, messages, chatMode, customName, customPrompt, politenessMode = 'polite', usedFluentMode = false) => {
  try {
    logger.debug('Saving conversation (API Client):', { userId, language, chatMode, messageCount: messages.length, customName, customPrompt, politenessMode, usedFluentMode });
    const data = await apiClient.post('/api/conversations', {
      userId,
      language,
      messages,
      chatMode,
      customName: customName || '',
      customPrompt: customPrompt || '',
      politenessMode: politenessMode || 'polite',
      usedFluentMode
    });
    logger.debug('Saved conversation (API Client response):', data);
    return data;
  } catch (error) {
    logger.error('Error saving conversation (API Client):', error);
    throw error;
  }
};

export const updateConversation = async (conversationId, messages) => {
  try {
    logger.debug('Updating conversation:', { conversationId, messageCount: messages.length });
    const response = await apiClient.put(`/api/conversations/${conversationId}`, {
      messages
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    logger.debug('Updated conversation:', data);
    return data;
  } catch (error) {
    logger.error('Error updating conversation:', error);
    throw error;
  }
};

export const deleteConversation = async (conversationId) => {
  try {
    logger.debug('Deleting conversation:', conversationId);
    const response = await apiClient.delete(`/api/conversations/${conversationId}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  } catch (error) {
    logger.error('Error deleting conversation:', error);
    throw error;
  }
};

export const resetConversations = async (userId, language) => {
  try {
    logger.debug('Resetting conversations for:', { userId, language });
    const response = await apiClient.delete(`/api/conversations/reset/${userId}/${language}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  } catch (error) {
    logger.error('Error resetting conversations:', error);
    throw error;
  }
}; 